import { APP_CONSTANTS } from 'src/consumer/constants'

import CalendarMonth from '@mui/icons-material/CalendarMonth'
import CalendarViewDay from '@mui/icons-material/CalendarViewDay'
import Home from '@mui/icons-material/Home'
import LiveHelp from '@mui/icons-material/LiveHelp'
import Lock from '@mui/icons-material/Lock'
import Policy from '@mui/icons-material/Policy'
import Settings from '@mui/icons-material/Settings'
import LocalHospital from '@mui/icons-material/LocalHospital'
import { Popover } from '@mui/material'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import kycIconSvg from 'src/assets/kyc approval.svg'
import { MentorLocalizationContext } from 'src/mentor/context/MentorLocalizationContext'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { GenericDisplayFlex } from 'src/mentor/layout/Styles'
import { getAllRolesInBoolean, getIsTeacherOrCreatorData } from 'src/mentor/layout/utils'
import {
  KycApprovalHeading,
  KycSidebarPendingContent,
  SidebarContainer,
  SidebarItemContainer,
  SidebarItemText,
  SidebarKycIcon,
  StyledLogo,
} from './MentorSidebarStyles'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import SummarizeIcon from '@mui/icons-material/Summarize'

export default function MentorSidebar() {
  const navigate = useNavigate()
  const localizedData = useContext(MentorLocalizationContext)
  const { mentorProfileData, allLegalPolicies, mentorClinicAssociationData } =
    useContext(MentorProfileContext)
  const offersLive = mentorProfileData?.services?.live
  const relevantRolesData = getIsTeacherOrCreatorData()
  const [popoverAnchor, setPopoverAnchor] = useState(null)

  const sidebarIconDisabledSx = {
    fontSize: { xs: '30px', md: '40px' },
    color: '#8b8b8b',
  }
  const sidebarIconSx = {
    fontSize: { xs: '30px', md: '40px' },
    color: '#fff',
  }

  function handleOpenPopover(event) {
    mentorProfileData?.kycStatus === 'pending' && setPopoverAnchor(event.currentTarget)
  }
  function handleClosePopover() {
    setPopoverAnchor(null)
  }

  return (
    <SidebarContainer className="hide-on-print-only">
      <StyledLogo
        src={APP_CONSTANTS.APP_LOGO_LINK}
        onError={(e) => {
          e.target.src = '/logo_brand.png'
        }}
        onClick={() => navigate('/mentor-home')}
      />
      <GenericDisplayFlex
        sb
        width="100%"
        onMouseEnter={handleOpenPopover}
        onMouseLeave={handleClosePopover}
        style={{ cursor: 'pointer' }}
        onClick={() => navigate('/mentor-home')}
      >
        <Home
          sx={mentorProfileData?.kycStatus === 'pending' ? sidebarIconDisabledSx : sidebarIconSx}
        />
        <SidebarItemContainer>
          <SidebarItemText disabled={mentorProfileData?.kycStatus === 'pending'}>
            Home
          </SidebarItemText>
          {mentorProfileData?.kycStatus === 'pending' && <Lock />}
        </SidebarItemContainer>
      </GenericDisplayFlex>

      {offersLive && !relevantRolesData?.isCreator && relevantRolesData?.isTeacher && (
        <GenericDisplayFlex
          width="100%"
          sb
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/mentor-home/my-calendar')}
        >
          <CalendarMonth
            sx={mentorProfileData?.kycStatus === 'pending' ? sidebarIconDisabledSx : sidebarIconSx}
          />
          <SidebarItemContainer>
            <SidebarItemText>Calendar Settings</SidebarItemText>
          </SidebarItemContainer>
        </GenericDisplayFlex>
      )}
      {/* {!!mentorProfileData?.services?.groupLive && (
        <GenericDisplayFlex
          width="100%"
          sb
          onMouseEnter={handleOpenPopover}
          onMouseLeave={handleClosePopover}
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/mentor-home/webinars')}
        >
          <Groups
            sx={mentorProfileData?.kycStatus === 'pending' ? sidebarIconDisabledSx : sidebarIconSx}
          />
          <SidebarItemContainer>
            <SidebarItemText disabled={mentorProfileData?.kycStatus === 'pending'}>
              Webinars
            </SidebarItemText>
            {mentorProfileData?.kycStatus === 'pending' && <Lock />}
          </SidebarItemContainer>
        </GenericDisplayFlex>
      )} */}
      {getAllRolesInBoolean().isDoctor && mentorProfileData?.allowedToPrescribe && (
        <GenericDisplayFlex
          width="100%"
          sb
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/mentor-home/prescription-templates')}
        >
          <SummarizeIcon
            sx={mentorProfileData?.kycStatus === 'pending' ? sidebarIconDisabledSx : sidebarIconSx}
          />
          <SidebarItemContainer>
            <SidebarItemText>Prescription Pads</SidebarItemText>
          </SidebarItemContainer>
        </GenericDisplayFlex>
      )}
      {getAllRolesInBoolean().isDoctor && (
        <GenericDisplayFlex
          width="100%"
          sb
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/mentor-home/fee-collection-report')}
        >
          <AccountBalanceWalletIcon
            sx={mentorProfileData?.kycStatus === 'pending' ? sidebarIconDisabledSx : sidebarIconSx}
          />
          <SidebarItemContainer>
            <SidebarItemText>Clinic Fee Collection Report</SidebarItemText>
          </SidebarItemContainer>
        </GenericDisplayFlex>
      )}
      {mentorProfileData.services.recorded &&
        mentorProfileData.contentCategories.includes('activity-plan') && (
          <GenericDisplayFlex
            width="100%"
            sb
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/mentor-home/homework-plans')}
          >
            <CalendarViewDay
              sx={
                mentorProfileData?.kycStatus === 'pending' ? sidebarIconDisabledSx : sidebarIconSx
              }
            />
            <SidebarItemContainer>
              <SidebarItemText>Homework Plans</SidebarItemText>
            </SidebarItemContainer>
          </GenericDisplayFlex>
        )}
      <GenericDisplayFlex
        width="100%"
        sb
        style={{ cursor: 'pointer' }}
        onClick={() => navigate('/mentor-home/faqs')}
      >
        <LiveHelp sx={sidebarIconSx} />
        <SidebarItemContainer>
          <SidebarItemText>FAQs</SidebarItemText>
        </SidebarItemContainer>
      </GenericDisplayFlex>
      {allLegalPolicies?.length > 0 && (
        <GenericDisplayFlex
          width="100%"
          sb
          onMouseEnter={handleOpenPopover}
          onMouseLeave={handleClosePopover}
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/mentor-home/agreements')}
        >
          <Policy
            sx={mentorProfileData?.kycStatus === 'pending' ? sidebarIconDisabledSx : sidebarIconSx}
          />
          <SidebarItemContainer>
            <SidebarItemText disabled={mentorProfileData?.kycStatus === 'pending'}>
              Agreements, Tax and Banking
            </SidebarItemText>
            {mentorProfileData?.kycStatus === 'pending' && <Lock />}
          </SidebarItemContainer>
        </GenericDisplayFlex>
      )}

      {mentorClinicAssociationData && mentorClinicAssociationData?.length > 0 && (
        <GenericDisplayFlex
          width="100%"
          sb
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/mentor-home/my-clinic-associations')}
        >
          <LocalHospital sx={sidebarIconSx} />
          <SidebarItemContainer>
            <SidebarItemText>Clinic Bookings</SidebarItemText>
          </SidebarItemContainer>
        </GenericDisplayFlex>
      )}
      {getAllRolesInBoolean().isDoctor && (
        <GenericDisplayFlex
          width="100%"
          sb
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/mentor-home/settings')}
        >
          <Settings sx={sidebarIconSx} />
          <SidebarItemContainer>
            <SidebarItemText>EMR Settings</SidebarItemText>
          </SidebarItemContainer>
        </GenericDisplayFlex>
      )}

      <GenericDisplayFlex
        width="100%"
        sb
        style={{ cursor: 'pointer' }}
        onClick={() => navigate('/mentor-home/profile')}
      >
        <Settings sx={sidebarIconSx} />
        <SidebarItemContainer>
          <SidebarItemText>Profile Settings</SidebarItemText>
        </SidebarItemContainer>
      </GenericDisplayFlex>

      <Popover
        open={Boolean(popoverAnchor)}
        anchorEl={popoverAnchor}
        sx={{
          pointerEvents: 'none',
        }}
        PaperProps={{ sx: { borderRadius: '15px' } }}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        disableRestoreFocus
      >
        <KycSidebarPendingContent>
          <SidebarKycIcon 
            src={kycIconSvg} 
            alt="KYC Approval Required"
            loading="lazy"
            decoding="async"
          />
          <KycApprovalHeading>
            To access this section<br></br>
            your KYC needs to be approved
          </KycApprovalHeading>
        </KycSidebarPendingContent>
      </Popover>
    </SidebarContainer>
  )
}
